import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Col, Empty, Row, Spin } from 'components';
import styles from './styles.module.scss';
import { CommentsGroup } from 'components/common/comments/CommentGroup';
import { useComments } from 'components/common/comments/useComments';

export interface IComments {
  entityName: string;
  id?: string;
}

export const Comments = ({ id }: IComments) => {
  const { isLoading, comments, lastLogRef, firstLogRef, scrollContainerRef, isFetchingNextPage } = useComments({ id });

  const containerStyle = {
    height: 'auto',
    overflowY: 'auto' as const,
    overflowX: 'hidden' as const,
  };

  return (
    <div className={styles.comments}>
      <Spin spinning={isLoading} indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}>
        <Row justify="space-between">
          <Col>
            <Row className={styles.title_container} align="middle">
              {/*<Col>*/}
              {/*  <Typography.Text className={'font-size-16'} style={{ color: '#05796B', fontWeight: 600 }}>*/}
              {/*    Comments*/}
              {/*  </Typography.Text>*/}
              {/*</Col>*/}
            </Row>
          </Col>
        </Row>
        <div className={styles.comments_container} style={containerStyle} ref={scrollContainerRef}>
          <Row>
            {comments && Object.keys(comments).length ? (
              Object.keys(comments).map((key, index) => (
                <CommentsGroup
                  key={key}
                  groupName={key}
                  comments={comments[key]}
                  lastLogRef={lastLogRef}
                  firstLogRef={firstLogRef}
                  isFirstGroup={index === 0}
                  isLastGroup={index === Object.keys(comments).length - 1}
                />
              ))
            ) : (
              <Empty description={'No Data'} style={{ margin: '10% auto 0' }} />
            )}
          </Row>
        </div>
        <Row justify={'center'} className={'margin-b-16'}>
          <Col span={24}>
            <Spin
              spinning={isFetchingNextPage}
              tip={'Loading Comments...'}
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            >
              <div />
            </Spin>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};
